import { FC, useContext, useEffect, useRef } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../../../context/notificationContext";
import useI18n from "../../../../../hooks/useTranslations";
import { useBasesApi } from "../../../../../http/border/useBases";
import BaseForm from "./BaseForm";

interface EditBaseProps {
  onClose: () => void;
  baseId: string;
}

const EditBase: FC<EditBaseProps> = ({ onClose, baseId }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const aborter = useRef(new AbortController());
  const baseApi = useBasesApi();

  const { data, error, trigger } = baseApi.getAdminBase(baseId, aborter.current.signal);

  useEffect(() => {
    error && dispatch(showErrorNotification(i18n, error));
  }, [error]);

  useEffect(() => {
    baseId && trigger();
  }, [baseId]);

  return <BaseForm onClose={onClose} base={data} isDisabled={!!error} isLoading={!data && !error} />;
};

export default EditBase;
